export const API_BASE = process.env.NODE_ENV === "production" ? "" : "http://localhost:3000";
export const GenderTypes = ["mr", "mrs", "mx", "no_selection"];